export interface AddressState {
  addressMap: Record<string, string>;
  loading: boolean;
  error?: string;
}

export const initialAddressState: AddressState = {
  addressMap: {},
  loading: false,
};
